import { useMemo, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { ProjectId, User } from 'api/models';
import { useStoreMembers } from 'data/members/hooks/use-store-members';
import { useMemberships } from 'hooks/use-memberships';
import { Content } from 'stores/core';
import { Memberships } from 'stores/memberships';

const projectMembers =
  (users: User[]) =>
  ({ users: members }: Memberships) => {
    return users.filter((x) => members.includes(x.userId));
  };

/**
 * @deprecated Avoid getting a list of objects from the store, prefer ids
 */
export const useProjectUsers = (projectId: ProjectId, forceReload = false) => {
  const memberships = useMemberships(projectId, forceReload);
  const { users = [] } = useStoreMembers();
  const mapper = useMemo(() => projectMembers(users), [users]);
  const [content, setContent] = useState<Content<User[]>>(
    Content.map(mapper)(memberships),
  );

  useDeepCompareEffect(() => {
    setContent(Content.map(mapper)(memberships));
  }, [users, memberships, setContent]);

  return content;
};
